import React from 'react';
import styled from 'styled-components';
import { getCurrentAutoFocusId } from './autofocus';

const StyledForm = styled.div`
	opacity: ${props => props.opacity};
	&:not(.virtual) {
		background-color: ${props => props.theme.formBackground};
		border-radius: ${props => props.theme.formBorderRadius};
		padding: ${props => props.theme.formPadding};
		box-shadow: ${props => props.theme.formShadow};
		border: ${props => props.theme.formBorder};
	}
	&.ps-form-vertical {
		.ps-formItem {
			display: block;
		}

		.ps-cross {
			display: flex;
			flex-direction: row;
			align-items: flex-start;

			vertical-align: top;

			> .ps-formItem:not([width]) {
				flex-grow: 1;
				flex-basis: 100%;
			}
			> .ps-formItem[width] {
				flex-shrink: 0;
			}
		}
	}

	&.ps-form-horizontal {
		display: flex;
		flex-wrap: wrap;
		margin-left: auto;
		margin-right: auto;
		flex-direction: row;

		.ps-formItem {
			display: inline-block;
			vertical-align: top;
			flex-grow: 1;
			flex-shrink: 0;
		}

		.ps-formItem:not([width]) {
			flex-grow: 1;
		}

		.ps-formItem[width] {
			flex-shrink: 0;
		}

	}
`;

export default class Form extends React.PureComponent {
	constructor() {
		super();

		this.formRef = React.createRef();
		this.onItemAction = this.onItemAction.bind(this);
		this.lastAppliedAutoFocusId = getCurrentAutoFocusId();
	}

	onItemAction(e) {
		if (e.defaultPrevented) {
			return;
		}
		window.setTimeout(() => {
			if (this.props.actionMode === 'all') {
				this.onAction();
			} else {
				this.focusNext(e.target);
			}
		}, 0);
	}

	onAction() {
		if (this.props.onAction) {
			this.props.onAction();
		}
	}

	focusNext(el) {
		const inputs = this.getInputs();
		const inputCount = inputs.length;
		const currIndex = Array.prototype.indexOf.call(inputs, el);
		if (currIndex < 0) {
			return;
		}
		let nextIndex = currIndex + 1;
		while (nextIndex < inputCount && inputs[nextIndex].readonly) {
			nextIndex++;
		}
		if (nextIndex >= inputCount) {
			this.onAction();
		} else {
			inputs[nextIndex].focus();
			inputs[nextIndex].select();
		}
	}

	getInputs() {
		const el = this.formRef.current;
		if (!el) {
			return [];
		}
		return el.querySelectorAll('input:not([readonly]),textarea');
	}

	focus(index) {
		const inps = this.getInputs();
		if (!inps[index]) {
			return;
		}
		while (inps[index].readonly) {
			index++;
			if (!inps[index]) {
				return;
			}
		}
		const inp = inps[index];
		if (inp) {
			window.setTimeout(() => {
				inp.focus();
				inp.select();
			}, 0);
		}
	}

	componentDidUpdate() {
		const currAutoFocusId = getCurrentAutoFocusId();
		if (currAutoFocusId > this.lastAppliedAutoFocusId) {
			let inps =  Array.prototype.filter.call(this.getInputs(), i => i.getAttribute('data-autofocusid') > this.lastAppliedAutoFocusId);
			this.lastAppliedAutoFocusId = currAutoFocusId;
			if (inps.length > 0) {
				inps[inps.length - 1].focus();
				window.setTimeout(() => {
					inps[inps.length - 1].select();
				}, 0);
			}
		}
	}

	componentDidMount() {
		this.formRef.current.addEventListener('action', this.onItemAction);
		window.setTimeout(() => {
			this.focus(0);
		}, 0);
	}

	componentWillUnmount() {
		this.formRef.current.removeEventListener('action', this.onItemAction);
	}

	render() {
		return (
			<StyledForm ref={this.formRef} opacity={this.props.opacity} className={'ps-form ' + (this.props.horizontal ? 'ps-form-horizontal' : 'ps-form-vertical') + (this.props.virtual ? ' virtual' : '')}>
				{this.props.children}
			</StyledForm>
		);
	}
}
